export default "__VITE_ASSET__7scfl0bX__"